import { createSlice } from "@reduxjs/toolkit";
import { IDLE, LOADING } from "@src/constants";
import { getFromServerTopic } from "../utility/slice";
import { logFilter } from "@logging";
import { SAVING } from "../constants";

const SLICE = "buildingLayout";

const TAG = "buildingLayoutSlice";
const log = (...params) => logFilter(TAG, ...params);
if (0) {
  log();
}

export const MODE_PLANNING = "Planning Mode";
export const MODE_COMMISSIONING = "Commissioning Mode";

export const REGISTRATION_STATUS = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};

// const action = (name) => `${SLICE}/${name}`;

export const getFromServer = (action, contextOptionsFn, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, contextOptionsFn, payloadFn });

// const getPortfolios = getFromServer("getPortfolios");

// const getBuildings = createAsyncThunk(
//   action("getBuildings"),
//   async (payload, { getState }) => {
//     const { lookupdata } = getState().persistedAppData;
//     return lookupdata.buildings;
//   }
// );

// export const initializePortfoliosPage = createAsyncThunk(
//   action("initializePortfoliosPage"),
//   async (arg, { dispatch }) =>
//     Promise.all([dispatch(getPortfolios()), dispatch(getBuildings())])
// );

export const getTileSetLookupData = getFromServer("getTileSetLookupData");

export const getAllEquipmentTemplates = getFromServer(
  "getAllEquipmentTemplates",
);

export const getAllDeviceSerialNumbers = getFromServer(
  "getAllDeviceSerialNumbers",
);

export const updateBuildingLayout = getFromServer(
  "updateBuildingLayout",
  async ({ arg }) => arg.floor_id,
  async (arg) => arg,
);

export const getBuildingLayout = getFromServer(
  "getBuildingLayout",
  async ({ arg }) => {
    return { siteId: arg };
  },
  async (arg) => arg,
);

export const getAllRegisteredFloors = getFromServer(
  "getAllRegisteredFloors",
  async ({ arg }) => arg,
  async (arg) => arg,
);

export const registerFloor = getFromServer(
  "registerFloor",
  async ({ arg }) => arg,
  async (arg) => arg,
);

export const getEquipmentData = getFromServer(
  "getEquipmentData",
  async ({ arg }) => arg,
  async (arg) => arg,
);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    equipment_templates: null,
    serialNumbers: null,
    status: LOADING,
    layout: null,
    site_id: null,
    floor_name: null,
    floor_id: null,
    mode: MODE_PLANNING,
    floorIdIsValid: true,
    registeredFloors: null,
    registrationStatus: null,
    TILE_SETS: null,
    equipmentData: null,
    // TODO: Hook these up to the editor layouts in 2d and 3d,
    // so that the choices are persisted
    editorLayout2D: "small",
    editorLayout3D: "small",
  },
  reducers: {
    setRegistrationStatus: (state, action) => {
      state.registrationStatus = action.payload;
    },
    changeLayoutMode: (state, action) => {
      const mode = action.payload;
      // if (mode === MODE_PLANNING) {
      //   log('ENTERING the planning mode');
      // }
      // if (mode === MODE_COMMISSIONING) {
      //   log('We are doing a Commissioning job!');
      // }
      state.mode = mode;
    },
  },
  extraReducers: (builder) => {
    builder
      // updateBuildingLayout
      .addCase(updateBuildingLayout.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(updateBuildingLayout.fulfilled, (state) => {
        state.status = IDLE;
      })

      // getTileSetLookupData
      .addCase(getTileSetLookupData.fulfilled, (state, action) => {
        const tileSets = action.payload.response;
        for (const [name, tileSet] of Object.entries(tileSets)) {
          for (const tileData of tileSet) {
            const { description } = tileData;
            tileData.url = `assets/buildingLayout/tiles/${name}/${description}.png`;
          }
        }
        const mapped = Object.entries(tileSets).reduce(
          (acc, [tileGroup, tileTypesData]) => {
            acc[tileGroup] = tileTypesData.reduce((acc, cur) => {
              acc[cur.description] = cur;
              return acc;
            }, {});
            return acc;
          },
          {},
        );
        state.TILE_SETS = {
          ...tileSets,
          DESC_MAP: { ...mapped },
        };
      })

      // getAllEquipmentTemplates
      .addCase(getAllEquipmentTemplates.fulfilled, (state, action) => {
        state.equipment_templates = action.payload.response;
      })

      // getAllDeviceSerialNumbers
      .addCase(getAllDeviceSerialNumbers.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(getAllDeviceSerialNumbers.fulfilled, (state, action) => {
        state.serialNumbers = action.payload.response;

        state.status = IDLE;
      })

      // getBuildingLayout
      .addCase(getBuildingLayout.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(getBuildingLayout.rejected, (state) => {
        log("getBuildingLayout rejected!");
        state.status = IDLE;
        state.layout = {};
      })
      .addCase(getBuildingLayout.fulfilled, (state, action) => {
        const { site_id, allFloors } = action.payload.response;
        const floors = {};
        allFloors.forEach(({ info, ...rest }) => {
          const { floor_id } = info;
          floors[floor_id] = { info, ...rest };
        });
        state.layout = { floors };
        state.site_id = site_id;
        state.status = IDLE;
      })

      // getAllRegisteredFloors
      .addCase(getAllRegisteredFloors.fulfilled, (state, action) => {
        state.registeredFloors = action.payload.response;
      })

      // registerFloor
      .addCase(registerFloor.pending, (state) => {
        state.registrationStatus = REGISTRATION_STATUS.PENDING;
      })
      .addCase(registerFloor.rejected, (state) => {
        state.registrationStatus = REGISTRATION_STATUS.FAILURE;
      })
      .addCase(registerFloor.fulfilled, (state, action) => {
        state.registrationStatus = REGISTRATION_STATUS.SUCCESS;
        state.registeredFloors = action.payload.response;
      })

      // getEquipmentData
      .addCase(getEquipmentData.pending, (state) => {
        state.equipmentData = null;
      })
      .addCase(getEquipmentData.fulfilled, (state, action) => {
        state.equipmentData = action.payload.response;
      });
  },
});

export const { changeLayoutMode, setRegistrationStatus } = slice.actions;

export const INITIAL_STATE = slice.getInitialState();

export default slice.reducer;
